var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlorida(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.705,56.972l2.422,7.505l-1.211,5.809h-4.118l-0.481-5.568c0,0-71.899,5.085-73.11,4.357 c-1.21-0.727-5.81-9.198-5.81-9.198L26.86,68.593v3.993l7.627,6.174l-1.454,9.805h4.6c0,0,8.715-3.752,12.83-3.752 c4.116,0,20.336-0.484,32.684,7.261c12.345,7.749,11.376,11.622,11.376,11.622s5.086-3.389,8.959-2.179 c3.872,1.21,11.619-7.267,11.619-7.267l6.053-0.964v-5.325c0,0,5.809-1.696,8.958-0.486c3.146,1.212,15.009,8.595,17.187,10.955 c2.178,2.361,7.264,7.687,7.264,7.687s4.357,3.39,11.619,5.568c0,0,5.084,8.231,7.021,9.442v13.315l-1.937,8.715l4.842,16.461 l3.146-6.537l-2.42-2.904l7.988,0.484l-7.022,14.283c0,0,14.284,18.398,20.337,29.051l2.904,1.453l1.696-3.392 c0,0,7.021,6.054,7.021,9.202c0,3.146,4.357,9.682,4.357,9.682h2.662c0,0,10.41,3.872,12.832,7.262 c2.418,3.39,3.389,15.01,7.018,14.043c3.635-0.969,19.369-6.538,19.854-9.927c0.482-3.389,0-12.83,0-12.83s4.113-0.727,3.871-3.632 c-0.242-2.904-1.691-28.324-3.632-33.408c-1.935-5.083-23.964-41.637-23.964-44.058l2.662-5.569l-2.18-3.873 c0,0-23.965-18.883-36.311-61.973l-14.285-1.694L180.705,56.972z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlorida);
export default __webpack_public_path__ + "static/media/florida.02d329e157178346fded16622eb84e56.svg";
export { ForwardRef as ReactComponent };